<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="商品编码" prop="goodsCode">
            <el-input v-model="searchForm.goodsCode" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input v-model="searchForm.goodsName" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="更新人员" prop="updatedBy">
            <el-input v-model="searchForm.updatedBy" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="更新时间">
            <form-date-range
              :form="searchForm"
              startKey="updatedDateStart"
              :usingTime="false"
              endKey="updatedDateEnd"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="goodsCode" label="商品编码" min-width="120"></el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="settlementPrice" label="结算价" min-width="100" align="center"></el-table-column>
        <el-table-column prop="settlementPrice10" label="极限价10%" min-width="100" align="center"></el-table-column>
        <el-table-column prop="settlementPrice15" label="极限价15%" min-width="100" align="center"></el-table-column>
        <el-table-column prop="settlementPrice20" label="极限价20%" min-width="100" align="center"></el-table-column>
        <el-table-column prop="reason" label="调整原因" min-width="120"></el-table-column>
        <el-table-column prop="updatedBy" label="更新人员" min-width="120"></el-table-column>
        <el-table-column prop="updatedDate" label="更新时间" min-width="160"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewDetails(row)">查看明细记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <adjusting-records-dialog
      :visible.sync="adjustingRecordsVisible"
      :rowData="rowData"
      v-if="adjustingRecordsVisible"
    />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import adjustingRecordsDialog from './components/adjusting-records-dialog.vue';
export default {
  name: 'settlementPriceMain',
  mixins: [tableMixin, pagePathMixin],
  components: {
    adjustingRecordsDialog,
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      adjustingRecordsVisible: false,
      searchFormData: [],
      rules: {},
      searchForm: {
        goodsCode: '',
        goodsName: '',
        updatedBy: '',
        updatedDateStart: '',
        updatedDateEnd: '',
        approvalStatus: '',
      },
      rowData: {},
    };
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let { updatedDateStart, updatedDateEnd } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          updatedDateStart: updatedDateStart ? updatedDateStart + ' 00:00:00' : '',
          updatedDateEnd: updatedDateEnd ? updatedDateEnd + ' 23:59:59' : '',
        },
      };
      this.searchFormData = data;
      this.$q.goods
        .goodsSettlementPricePage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;  
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    // 查看详情
    viewDetails(row) {
      this.rowData = row;
      this.adjustingRecordsVisible = true;
    },

    //导入
    importExcel() {
      this.openSubPage({
        path: '/goods/settlementPriceMainImport',
        query: {
          fileName: '包件结算价格维护导入.xlsx',
          appCode: 'ec-pc-new',
          reportName: 'settlementPriceMainImport',
        },
      });
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'goodsSettlementPricePage',
      };
      this.$q.common
        .exportExcel({ data: params })
        .then(res => {
          if (res.success) {
            this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(_ => {
          loading.close();
        });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}
</style>
